module.exports = "https://cdn.realtymogul.com/static/media/Christina_L.ff3c7e80.jpg";